import axios from "axios";
import NProgress from "nprogress";

const apiShipping = axios.create({
  baseURL: "https://api.icap-maker.com/",
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  }
});

apiShipping.interceptors.request.use(config => {
  NProgress.start();
  return config;
});

apiShipping.interceptors.response.use(response => {
  NProgress.done();
  return response;
});

export default {
  //   get_subtotals(value) {
  //     return new Promise((resolve, reject) => {
  //       apiShipping({
  //         method: "post",
  //         url: "/Shipping/SubTotals/",
  //         data: {
  //           _monthID: value
  //         }
  //       })
  //         .then(response => {
  //           resolve(response)
  //         })
  //         .catch(error => {
  //           reject(error)
  //         })
  //     })
  //   }
  get_subtotals(value) {
    return apiShipping({
      method: "post",
      url: "/Shipping/SubTotals/",
      data: {
        _monthID: value
      }
    });
  },
  get_orders() {
    return apiShipping({
      method: "get",
      url: "/Shipping/Orders/"
      //   ,
      //   data: {
      //     _monthID: value
      //   }
    });
  },
  get_mail_tracker_link() {
    return apiShipping({
      method: "get",
      url: "/Shipping/TrackingLink/"
    });
  },
  get_ordersByMonth(value) {
    return apiShipping({
      method: "post",
      url: "/Shipping/MonthlyOrders/",
      data: {
        _shippingMonthID: value
      }
    });
  },
  Load_ShippingOrder(value) {
    return apiShipping({
      method: "post",
      url: "/Shipping/Shipment/",
      data: {
        _orderid: value
      }
    });
  },
  get_shipMethodReportLines(value) {
    return apiShipping({
      method: "post",
      url: "/Shipping/ShippingMethodReport/",
      data: {
        _batchID: value
      }
    });
  },
  get_shipStatusReportLines(value) {
    return apiShipping({
      method: "post",
      url: "/Shipping/ShippingStatusReport/",
      data: {
        _batchID: value
      }
    });
  },
  get_shipByDateReportLines(value) {
    return apiShipping({
      method: "post",
      url: "/Shipping/ShippedByDateReport/",
      data: {
        _batchID: value
      }
    });
  },
  post_notification(notification) {
    return apiShipping({
      method: "post",
      url: "/Shipping/ShipNotification/",
      data: {
        _notification: notification
      }
    });
  },
  CreateDownloadFile(op) {
    return apiShipping({
      method: "post",
      url: "/Shipping/Download/",
      data: {
        _op: op
      }
    });
  },
  activeMonths() {
    return apiShipping({
      method: "get",
      url: "/Shipping/Months/"
      //   ,
      //   data: {
      //     _monthID: value
      //   }
    });
  },
  shipMethods() {
    return apiShipping({
      method: "get",
      url: "/Shipping/Methods/"
      //   ,
      //   data: {
      //     _monthID: value
      //   }
    });
  },
  FilterByStatus(op) {
    return apiShipping({
      method: "post",
      url: "/Shipping/FilterByDeliveryStatus/",
      data: {
        _monthID: op.MonthID,
        _status: op.Status
      }
    });
  }
};
